// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer___1BHfS","links":"links___3es9g","link":"link___wQJKd","copyright":"copyright___161z3","description":"description___3_4z_"};